import React from 'react';
import PropTypes from 'prop-types';
import {utils, writeFile} from 'xlsx';
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import {isEmpty, extractWorkSheetData, formatDate, ExcelDateToDateString} from "../../globals/GlobalFunctions";

export interface Props {
    excelData: any;
}

//comma delimited format
function MedefyFormatter ({excelData}: Props) {
    const [successAlert, setSuccessAlert] = React.useState(false);
    const [errorAlert, setErrorAlert] = React.useState(false);
    try{
        //Check for 2 sheets here
        if (!isEmpty(excelData) && excelData.Sheets.Medefy !== undefined) {
            let sheetDataArray = extractWorkSheetData(excelData.Sheets.Medefy);

            let rawCellArray: any[] = sheetDataArray[0];

            let columnRange: number = sheetDataArray[1];

            let rowRange: number = sheetDataArray[2];

            const valuesIndexCollection = {
                memberSegIndex: rawCellArray.indexOf('Member Sequence') + 1,
                subscriberSSNIndex: rawCellArray.indexOf('Subscriber SSN') + 1,
                altIDIndex: rawCellArray.indexOf('Member Alternate ID') + 1,
                fnIndex: rawCellArray.indexOf('Member First Name') + 1,
                mnIndex: rawCellArray.indexOf('Member Middle Name') + 1,
                lnIndex: rawCellArray.indexOf('Member Last Name') + 1,
                planIndex: rawCellArray.indexOf('Plan ID') + 1,
                divisionIndex: rawCellArray.indexOf('Division ID') + 1,
                dobIndex: rawCellArray.indexOf('Member Date of Birth') + 1,
                subscriberIndex: rawCellArray.indexOf('Subscriber ID') + 1,
                phoneIndex: rawCellArray.indexOf('Member Home Phone') + 1,
                enrollDateIndex: rawCellArray.indexOf('Effective Date') + 1,
                disenrollDateIndex: rawCellArray.indexOf('Termination Date') + 1,
                groupIndex: rawCellArray.indexOf('Group ID') + 1,
                memberSSNIndex: rawCellArray.indexOf('Member SSN') + 1,
                sexIndex: rawCellArray.indexOf('Member Gender') + 1,
                addIndex: rawCellArray.indexOf('Member Address') + 1,
                add2Index: rawCellArray.indexOf('Member Address 2') + 1,
                cityIndex: rawCellArray.indexOf('Member City') + 1,
                stateIndex: rawCellArray.indexOf('Member State') + 1,
                zipIndex: rawCellArray.indexOf('Member Zip Code') + 1,
                emailIndex: rawCellArray.indexOf('Member Email Address') + 1,
            }

            let arrayOfMemberArrays: any[] = [[
                "Group Number,Plan Code,Subscriber ID,Member ID,Member Sequence ID,Coverage Start Date,Coverage End Date,Relationship,Member SSN,Member Last Name," +
                "Member First Name,Member Middle Initiial,Member Suffix,Member Gender,Member DOB,Member Address line 1,Member Address line 2,Member City,Member State," +
                "Member Zip Code,Member Phone,Member Email"
            ]];

            for (let i = 1; i < rowRange; i++) {
                //our member to later be pushed. Oh from what humble origins it begins
                let memberArray: any[] = [];
                let memberString: string = "";
                //for each new member array we skip over the previous members determined by the column length, removing 1 to account for our zero based index at the beginning
                let rowMultiplier = columnRange * i - 1;

                let today = new Date();

                let termDate = new Date(Math.round((rawCellArray[(rowMultiplier + valuesIndexCollection.disenrollDateIndex)] - 25568)*86400*1000));

                //exclude terms
                if (termDate > today) {

                    if (valuesIndexCollection.groupIndex > 0 && valuesIndexCollection.planIndex > 0) {
                        memberString += (rawCellArray[(rowMultiplier + valuesIndexCollection.groupIndex)].toString() + "," +
                            rawCellArray[(rowMultiplier + valuesIndexCollection.planIndex)].toString() + ",");
                    } else {
                        memberString += ",,";
                    }

                    //if not alt id then sub ID + 01
                    if (valuesIndexCollection.altIDIndex > 0) {
                        if (rawCellArray[(rowMultiplier + valuesIndexCollection.altIDIndex)].toString().length > 0) {
                            memberString += (rawCellArray[(rowMultiplier + valuesIndexCollection.altIDIndex)].toString() + ",");
                        } else if (valuesIndexCollection.subscriberIndex > 0 && rawCellArray[(rowMultiplier + valuesIndexCollection.subscriberIndex)].toString().length > 0) {
                            memberString += (rawCellArray[(rowMultiplier + valuesIndexCollection.subscriberIndex)].toString() + ",");
                        } else {
                            memberString += ",";
                        }
                    } else {
                        memberString += ",";
                    }

                    //member ID
                    if (valuesIndexCollection.altIDIndex > 0 && valuesIndexCollection.memberSegIndex > 0) {
                        if (rawCellArray[(rowMultiplier + valuesIndexCollection.altIDIndex)].toString().length > 0) {
                            memberString += (rawCellArray[(rowMultiplier + valuesIndexCollection.altIDIndex)].toString() +
                                rawCellArray[(rowMultiplier + valuesIndexCollection.memberSegIndex)].toString() + ",");
                        } else if (valuesIndexCollection.subscriberIndex > 0 && rawCellArray[(rowMultiplier + valuesIndexCollection.subscriberIndex)].toString().length > 0) {
                            memberString += (rawCellArray[(rowMultiplier + valuesIndexCollection.subscriberIndex)].toString() +
                                rawCellArray[(rowMultiplier + valuesIndexCollection.memberSegIndex)].toString() + ",");
                        } else {
                            memberString += ",";
                        }
                    } else {
                        memberString += ",";
                    }

                    if (valuesIndexCollection.memberSegIndex > 0) {
                        memberString += (rawCellArray[(rowMultiplier + valuesIndexCollection.memberSegIndex)].toString() + ",");
                    } else {
                        memberString += ",";
                    }

                    if (valuesIndexCollection.enrollDateIndex > 0) {
                        let date = rawCellArray[(rowMultiplier + valuesIndexCollection.enrollDateIndex)].toString();
                        if (date.includes("/")) {
                            date = formatDate(date);
                        } else if (date.length > 0 && date.length < 6) {
                            date = ExcelDateToDateString(date);
                        }
                        if (date.length > 7) {
                            date = date.substring(4, 6) + "/" + date.substring(6, 8) + "/" + date.substring(0, 4);
                        }
                        memberString += (date + ",");
                    } else {
                        memberString += ",";
                    }

                    //remove 12/31/2222
                    if (valuesIndexCollection.disenrollDateIndex > 0) {
                        let date = rawCellArray[(rowMultiplier + valuesIndexCollection.disenrollDateIndex)].toString();
                        if (date.includes("/")) {
                            date = formatDate(date);
                        } else if (date.length > 0 && date.length < 6) {
                            date = ExcelDateToDateString(date);
                        }
                        if (date.length > 7) {
                            date = date.substring(4, 6) + "/" + date.substring(6, 8) + "/" + date.substring(0, 4);
                        }else if (date === "117974") {
                            date = "";
                        }
                        memberString += (date + ",");
                    } else {
                        memberString += ",";
                    }

                    if (valuesIndexCollection.memberSegIndex > 0) {
                        memberString += (rawCellArray[(rowMultiplier + valuesIndexCollection.memberSegIndex)].toString() + ",");
                    } else {
                        memberString += ",";
                    }

                    if (valuesIndexCollection.memberSSNIndex > 0) {
                        memberString += (rawCellArray[(rowMultiplier + valuesIndexCollection.memberSSNIndex)].toString() + ",");
                    } else {
                        memberString += ",";
                    }

                    if (valuesIndexCollection.lnIndex > 0) {
                        memberString += (rawCellArray[(rowMultiplier + valuesIndexCollection.lnIndex)].toString() + ",");
                    } else {
                        memberString += ",";
                    }

                    if (valuesIndexCollection.fnIndex > 0) {
                        memberString += (rawCellArray[(rowMultiplier + valuesIndexCollection.fnIndex)].toString() + ",");
                    } else {
                        memberString += ",";
                    }

                    if (valuesIndexCollection.mnIndex > 0) {
                        memberString += (rawCellArray[(rowMultiplier + valuesIndexCollection.mnIndex)].toString() + ",");
                    } else {
                        memberString += ",";
                    }

                    memberString += ",";

                    if (valuesIndexCollection.sexIndex > 0) {
                        memberString += (rawCellArray[(rowMultiplier + valuesIndexCollection.sexIndex)].toString() + ",");
                    } else {
                        memberString += ",";
                    }

                    if (valuesIndexCollection.dobIndex > 0) {
                        let date = rawCellArray[(rowMultiplier + valuesIndexCollection.dobIndex)].toString();
                        if (date.includes("/")) {
                            date = formatDate(date);
                        } else if (date.length > 0 && date.length < 6) {
                            date = ExcelDateToDateString(date);
                        }
                        if (date.length > 7) {
                            date = date.substring(4, 6) + "/" + date.substring(6, 8) + "/" + date.substring(0, 4);
                        }
                        memberString += (date + ",");
                    } else {
                        memberString += ",";
                    }

                    if (valuesIndexCollection.addIndex > 0) {
                        memberString += (rawCellArray[(rowMultiplier + valuesIndexCollection.addIndex)].toString() + ",");
                    } else {
                        memberString += ",";
                    }

                    if (valuesIndexCollection.add2Index > 0) {
                        memberString += (rawCellArray[(rowMultiplier + valuesIndexCollection.add2Index)].toString() + ",");
                    } else {
                        memberString += ",";
                    }

                    if (valuesIndexCollection.cityIndex > 0) {
                        memberString += (rawCellArray[(rowMultiplier + valuesIndexCollection.cityIndex)].toString() + ",");
                    } else {
                        memberString += ",";
                    }

                    if (valuesIndexCollection.stateIndex > 0) {
                        memberString += (rawCellArray[(rowMultiplier + valuesIndexCollection.stateIndex)].toString() + ",");
                    } else {
                        memberString += ",";
                    }

                    if (valuesIndexCollection.zipIndex > 0) {
                        memberString += (rawCellArray[(rowMultiplier + valuesIndexCollection.zipIndex)].toString() + ",");
                    } else {
                        memberString += ",";
                    }

                    if (valuesIndexCollection.phoneIndex > 0) {
                        memberString += (rawCellArray[(rowMultiplier + valuesIndexCollection.phoneIndex)].toString() + ",");
                    } else {
                        memberString += ",";
                    }

                    if (valuesIndexCollection.emailIndex > 0) {
                        memberString += (rawCellArray[(rowMultiplier + valuesIndexCollection.emailIndex)].toString() + ",");
                    } else {
                        memberString += ",";
                    }

                    memberArray.push(memberString);

                    arrayOfMemberArrays.push(memberArray);
                }
            }

            //create our workbook
            const eligWorkbook = utils.book_new();
            //make the member sheet from our member array of arrays
            let ws1 = utils.aoa_to_sheet(arrayOfMemberArrays, {dateNF: 'mm.dd.yyyy'});

            const today = new Date();

            const month = today.getMonth() + 1;

            let monthString = "";

            let dayString = "";

            if(month < 10){
                monthString = "0" + month.toString();
            }
            else{
                monthString = month.toString();
            }

            const day = today.getDate();

            if(day < 10) {
                dayString = "0" + day.toString();
            }
            else {
                dayString = day.toString();
            }

            const year = today.getFullYear();

            //add it to the new workbook
            utils.book_append_sheet(eligWorkbook, ws1, "Medefy_Elig_" + monthString + dayString + year);
            //it exists and has a sheet send it back to app for export
            if (eligWorkbook && eligWorkbook.SheetNames.includes("Medefy_Elig_" + monthString + dayString + year)) {
                if (!eligWorkbook.Props) eligWorkbook.Props = {};

                //setting the workbook title through props
                eligWorkbook.Props.Title = "Medefy_Elig_" + monthString + dayString + year + ".txt";

                //writing the file which will make the download, second param is the name of the file and third is required options
                writeFile(eligWorkbook, "Medefy_Elig_" + monthString + dayString + year + ".txt", {});

                console.log("File Export Complete!");
                setSuccessAlert(true);
            } else {
                setErrorAlert(true);
                console.log("Unknown Export Error!");
            }

            //clear it out at the end in case of rerendering
            excelData.Sheets.Medefy = undefined;
        }
    }
    catch(e) {
        console.log("ERROR", e);

        setErrorAlert(true);
        //clear it out after errors in case of rerendering otherwise the error spams will continue until morale improves
        excelData.Sheets.Medefy = undefined;

    }
    return (
        <div>
            {successAlert ? <Alert severity='success' onClose={() => setSuccessAlert(false)} variant="filled">
                <AlertTitle>Success!</AlertTitle>
                File Download Complete!
            </Alert> : <></> }
            {errorAlert ? <Alert severity='error' onClose={() => setErrorAlert(false)} variant="filled">
                <AlertTitle>Error!</AlertTitle>
                There was an error with this file!
            </Alert> : <></> }
        </div>
    );
}


export default React.memo(MedefyFormatter)

MedefyFormatter.propTypes = {
    excelData: PropTypes.object.isRequired,
};